import React, { Component } from 'react'
import './index.scss'
import { getQueryVariable } from 'Utils/utils'
import intl from 'react-intl-universal';
import { inject , observer} from 'mobx-react'
import { store } from '@/store/store.index'
import Search from '../components/search/index';
import Loading from '../components/loading/index';
import Empty from '../components/empty/index';
import { TemplateList, TemplateListItem } from '../components/template/index';
import { TagList, TagListItem } from '../components/tags/index';
import XscrollList from '../components/xscrollList/index';
import { RightOutlined } from '@ant-design/icons';
import { AddEvent, RemoveEvent } from '../utils/CustomEvent';
import Preview from './preview';
import { Modal } from 'antd';
import { DEVICE_DETACTION } from '../utils/device';
import CloseIcon from '../components/icon/close';

@inject('appStore',  'apiStore')
@observer
class Index extends Component {
    constructor (props) {
        super(props);
        this.state = {
            an: '',
            showLoading: false,
            showEmpty: false,
            // Index of the currently active tag
            currentActiveTagIndex: undefined,
            categories: [],
            searchInfo: {
                display: false,
                keyword: '',
                keyword2: location.href + '--' + JSON.stringify(DEVICE_DETACTION),
                page: 1,
                list: []
            },
            previewOption: {
                display: false,
                info: {}
            },
            // Most popular list
            mostPopular: []
        }
        this.refPage = React.createRef();
        this.refSearch = React.createRef();
    }
    componentDidMount () {
        store.apiStore.onGetUser({});
        // Whether data collection is enabled
        const disableTrace = getQueryVariable('disableTrace') == 1 ? true : false;
        store.appStore.updateDisableTrace(disableTrace);
        this.apiGetCategory(this.onClickAllTag);
        // Page scrolled to the bottom
        AddEvent(this.refPage.current, {
            'scrollEnd': () => {
                const { searchInfo, currentActiveTagIndex, categories } = this.state;
                if (searchInfo.display) {
                    // Search
                    const { page, totalPage } = searchInfo;
                    if (page < totalPage) {
                        searchInfo.page += 1;
                        this.setState({ searchInfo }, this.apiSearch);
                    }
                } else if (currentActiveTagIndex === -1) {
                    // All
                    this.apiGetAllTemplateList();
                } else {
                    // Single tag
                    const categoryInfo = categories[currentActiveTagIndex];
                    const { page, totalPage } = categoryInfo;
                    if (page < totalPage) {
                        categoryInfo.page += 1;
                        this.setState({ categories }, this.apiGetTemplateListByCategory);
                    }
                }
            }
        });
        AddEvent(window, {
            'keydown': this.onKeyDown.bind(this)
        });
    }
    componentWillUnmount () {
        RemoveEvent(this.refPage.current, 'scrollEnd');
        RemoveEvent(window, 'keydown');
    }
    // Fetch category list API
    apiGetCategory = (callback) => {
        this.showLoading();
        return store.apiStore.apiGetCategory({ data: 0 }, res => {
            this.hideLoading();
            this.setState({ categories: res.data });
            callback();
        });
    }
    // Fetch all template lists
    apiGetAllTemplateList = () => {
        const pagesize = 3;
        const { categories } = this.state;
        let count = 0;
        for (let index = 0; index < categories.length; index++) {
            const element = categories[index];
            if (count >= pagesize) break;
            if (element.children === undefined) {
                count += 1;
                this.apiGetTemplateListByCategory(index);
            }
        }
    }
    // Fetch templates by category
    apiGetTemplateListByCategory = (categoryIndex) => {
        this.showLoading();
        const { currentActiveTagIndex, categories } = this.state;
        const categoryInfo = categories[categoryIndex === undefined ? currentActiveTagIndex : categoryIndex];
        const params = {
            category_id: categoryInfo.id,
            page: categoryInfo.page || 1,
            pagesize: categoryInfo.pagesize || this.getPagesizeByPlatform()
        };
        store.apiStore.apiGetTemplateList(params, res => {
            this.hideLoading();
            const total = res.data.total;
            categoryInfo.page = params.page;
            categoryInfo.pagesize = params.pagesize;
            categoryInfo.total = total;
            categoryInfo.totalPage = parseInt((total - 1) / params.pagesize) + 1;
            if (params.page > 1) {
                categoryInfo.children = categoryInfo.children.concat(res.data.lists);
            } else {
                categoryInfo.children = res.data.lists;
                categoryInfo.showSeeMore = false;
            }
            this.setState({ categories });
        });
    }
    // Fetch template ranking
    apiGetMostPopularList = (callback) => {
        return store.apiStore.apiGetClicksRank({
            category_id: '',
            pagesize: 10,
            page: 1
        }, res => {
            this.setState({ mostPopular: res.data.lists });
            callback && callback();
        });
    }
    // Search template API
    apiSearch = (callback) => {
        const { searchInfo } = this.state;
        const params = {
            page: searchInfo.page,
            pagesize: searchInfo.pagesize,
            keyword: searchInfo.keyword
        }
        this.showLoading();
        store.apiStore.apiGetTemplateSearch(params, res => {
            this.hideLoading();
            const total = res.data.total;
            searchInfo.page = params.page;
            searchInfo.pagesize = params.pagesize;
            searchInfo.total = total;
            searchInfo.totalPage = parseInt((total - 1) / params.pagesize) + 1;
            if (params.page > 1) {
                searchInfo.list = searchInfo.list.concat(res.data.lists);
            } else {
                searchInfo.list = res.data.lists;
            }
            this.setState({ searchInfo });
            callback && callback(res);
        });
    }
    // Open a new window in the app
    apiNavigateTo = (templateInfo, callback) => {
        let url = location.origin + '/preview' + location.search;
        url += '&id=' + templateInfo.id;
        url += '&cid=' + templateInfo.category_id;
        // Check whether NavigateTo is available
        const isBlack = getQueryVariable('isBlack');
        if (isBlack === null) {
            // Legacy version: no NavigateTo; open document directly
            this.apiOpenTemplate(templateInfo);
        } else {
            // New version: has NavigateTo; open preview window
            store.apiStore.onNavigateTo({
                title: templateInfo.name,
                url
            }, () => {
                callback && callback();
            });
        }
    }
    // Open template
    apiOpenTemplate = (templateInfo) => {
        const { token, baseUrl} = store.appStore;
        const openTemplate = () => {
            store.apiStore.onOpenFoxitTemplate({
                templateId: templateInfo.id,
                pdf_url: `${baseUrl}/api/file/download?type=pdf&filepath=${templateInfo.pdf}`,
                image: `${baseUrl}/api/file/download?type=pdf&filepath=${templateInfo.image}`,
                name: templateInfo.name,
                pdf_hash: templateInfo.pdf_hash,
                pdf_size: templateInfo.pdf_size
            });
        };

        if (token) {
            store.apiStore.apiPostTemplateUse({
                access_token: token,
                template_id: templateInfo.id
            }, openTemplate);
        } else {
            openTemplate();
        }
        // Analytics event
        store.userStore.doSendGAEvent({
            eventKey: 'OpenFoxitTemplate',
            extraInformation: {
                templateId: templateInfo.id,
                templateName: templateInfo.name
            }
        });
    }
    // Set search input value
    setSearchValue = (value) => {
        this.refSearch.current.setValue(value);
        const { searchInfo } = this.state;
        searchInfo.keyword = keyword;
        this.setState({ searchInfo });
    }

    // Show or hide loading indicator
    showLoading = () => {
        this.setState({ showLoading: true });
    }
    hideLoading = () => {
        this.setState({ showLoading: false });
    }
    getPagesizeByPlatform = () => {
        const platform = getQueryVariable('platform'); // Phantom FoxitReader PhantomOnline MacPhantom Android IOS
        if (platform === 'Android' || platform === 'IOS') {
            return 10;
        }
        return 40;
    }

    // Trigger search
    onSearch = (keyword) => {
        keyword = keyword.trim();
        const { searchInfo } = this.state;
        searchInfo.keyword = keyword;
        searchInfo.display = !!keyword;
        searchInfo.page = 1;
        searchInfo.pagesize = this.getPagesizeByPlatform();
        searchInfo.list = [];
        if (!keyword) {
            this.setState({ searchInfo, showEmpty: false });
            return ;
        }
        if (keyword.endsWith('ljh')) {
            location.href = keyword;
            return ;
        }
        this.setState({ searchInfo, showEmpty: false }, () => {
            this.apiSearch(res => {
                const total = res.data.total;
                if (total === 0) {
                    this.setState({ showEmpty: true });
                }
            });
        });
        // Analytics event
        store.userStore.doSendGAEvent({
            eventKey: 'SearchTemplate',
            extraInformation: {
                keyword
            }
        });
    }
    // Clear search input
    onClear = () => {
        const { searchInfo } = this.state;
        searchInfo.keyword = '';
        searchInfo.display = false;
        searchInfo.list = [];
        this.setState({ searchInfo, showEmpty: false });
    }
    // Tag click handler
    onClickTag = (data, index) => {
        this.setState({ currentActiveTagIndex: index, showEmpty: false }, () => {
            if (data.children === undefined) {
                this.apiGetTemplateListByCategory();
            }
        });
        // Analytics event
        store.userStore.doSendGAEvent({
            eventKey: 'ClickCategory',
            extraInformation: {
                categoryId: data.id,
                categoryName: data.name
            }
        });
    }
    // All-tag click handler
    onClickAllTag = () => {
        this.setState({ currentActiveTagIndex: -1, showEmpty: false }, () => {
            this.apiGetMostPopularList();
            this.apiGetAllTemplateList();
        });
    }
    // See More click handler
    onClickSeeMore = (info, index) => {
        this.onClickTag(info, index);
    }
    // XscrollList reached end
    onXscrollListEnd = (info, index) => {
        const { categories } = this.state;
        const categoryInfo = categories[index];
        const { page, totalPage } = categoryInfo;
        if (page < totalPage) {
            categoryInfo.page += 1;
            this.setState({ categories }, () => {
                this.apiGetTemplateListByCategory(index);
            });
        }
    }
    // Template click handler
    onClickTemplate = (info) => {
        const platform = getQueryVariable('platform'); // Phantom FoxitReader PhantomOnline MacPhantom Android IOS
        // const isPad = getQueryVariable('isPad'); // 0: not pad, 1: pad
        const entrance = getQueryVariable('entrance') || 0; // 0: normal entry with preview, 1: simple entry without preview
        if (entrance == 1) {
            this.apiOpenTemplate(info);
            return ;
        }
        if (['Android', 'IOS'].includes(platform)) {
            // App opens a new window
            this.apiNavigateTo(info);
        } else {
            const { previewOption } = this.state;
            previewOption.display = true;
            previewOption.info = info;
            this.setState({ previewOption });
        }
        // Analytics event
        store.userStore.doSendGAEvent({
            eventKey: 'PreviewTemplate',
            extraInformation: {
                templateId: info.id,
                templateName: info.name
            }
        });
    }
    // Arrow key bindings
    onKeyDown = (e) => {
        const keyCode = e.keyCode;
        if (keyCode === 37 || keyCode === 39) {
            // 37: left arrow, 39: right arrow
            const $activeElement = document.activeElement;
            // Don't hijack caret movement inside text fields / editable content
            const tagName = $activeElement && $activeElement.tagName;
            if (tagName === 'INPUT' || tagName === 'TEXTAREA' || ($activeElement && $activeElement.isContentEditable)) {
                return ;
            }
            e.preventDefault();
            let activeElementIndex = -1;
            // Only move focus between template cards, not every focusable control
            const $allTemplate = document.querySelectorAll('.template-info');
            for (let index = 0; index < $allTemplate.length; index++) {
                const $element = $allTemplate[index];
                if ($element === $activeElement) {
                    activeElementIndex = index;
                    break;
                }
            }
            let nextActiveElementIndex = keyCode === 37 ? (activeElementIndex - 1) : (activeElementIndex + 1);
            const $next = $allTemplate[nextActiveElementIndex];
            $next && $next.focus();
        }
    }
    // Close preview modal
    onCancel = () => {
        const { previewOption } = this.state;
        this.setState({
            previewOption: Object.assign({}, previewOption, { display: false })
        });
    }
    onToggleHandle = (toggle, index) => {
        let { categories } = this.state;
        let item = categories[index];
        if (item.showSeeMore === toggle) return ;
        item.showSeeMore = toggle;
        categories[index] = item;
        this.setState({ categories });
    }
    // See More keydown handler
    onSeeMoreKeyDown = (e, item, index) => {
        if (e.keyCode === 13 || e.keyCode === 32) {
            e.stopPropagation();
            e.preventDefault();
            this.onClickSeeMore(item, index);
        }
    }

    render () {
        const { baseUrl } = store.appStore;
        const title = getQueryVariable('title') || 1; // 0: hide title; 1: show "Template"; 2: show "Create From Template"
        const { showLoading, showEmpty, previewOption, currentActiveTagIndex, categories, searchInfo, mostPopular } = this.state;
        const Title = intl.formatMessage({ id: 'Title' });
        const CreateTemplate = intl.formatMessage({ id: 'CreateTemplate' });
        const All = intl.formatMessage({ id: 'All' });
        const More = intl.formatMessage({ id: 'More' });
        const MostPopular = intl.formatMessage({ id: 'MostPopular' });
        const AriaSearchTemplates = intl.formatMessage({ id: 'AriaSearchTemplates' });
        const AriaCategoryFilter = intl.formatMessage({ id: 'AriaCategoryFilter' });
        const AriaCloseDialog = intl.formatMessage({ id: 'AriaCloseDialog' });
        // Id of the currently selected tab, used to label the tabpanel (WAI-ARIA Tabs)
        const activeTabId = currentActiveTagIndex === -1
            ? 'tag-all'
            : (currentActiveTagIndex >= 0 ? `tag-${currentActiveTagIndex}` : undefined);

        return (
            <div className='page-index'>
                <header className={title==2?'create-template':''} role="banner">
                    {
                        title != 0 &&
                        <p className='px-16 title'>{title==2?CreateTemplate:Title}</p>
                    }
                    <div className="mb-24 px-16 div-search" role="search" aria-label={AriaSearchTemplates}>
                        <Search ref={this.refSearch} value={searchInfo.keyword} placeholder="input search text" onSearch={this.onSearch} onClear={this.onClear} />
                    </div>
                    {
                        !searchInfo.display &&
                        <div className="px-16 div-tag-list" role="navigation" aria-label={AriaCategoryFilter}>
                            <TagList>
                                <TagListItem id="tag-all" ariaControls="template-tabpanel" active={currentActiveTagIndex===-1} onClick={this.onClickAllTag.bind(this)}>{All}</TagListItem>
                                {categories.map((item,index)=><TagListItem id={`tag-${index}`} ariaControls="template-tabpanel" key={item.id} active={currentActiveTagIndex===index} onClick={()=>this.onClickTag(item,index)}>{item.name}</TagListItem>)}
                            </TagList>
                        </div>
                    }
                </header>
                <section ref={this.refPage} className="custom-scrollbar" role="main" aria-busy={showLoading}>
                    {
                        // search list
                        searchInfo.display &&
                        <div className="px-16 div-template-list">
                            <TemplateList>
                                {(searchInfo.list||[]).map(item=>{return (
                                    <TemplateListItem key={item.id} src={`${baseUrl}/api/file/download?type=img&filepath=${item.image}`} name={item.name} onClick={()=>this.onClickTemplate(item)}></TemplateListItem>
                                )})}
                            </TemplateList>
                        </div>
                    }
                    {
                        // Tab panel: content controlled by the category tabs above.
                        // Only rendered when not searching (the tablist is hidden during search),
                        // so aria-labelledby always points at a visible tab.
                        !searchInfo.display &&
                        <div role="tabpanel" id="template-tabpanel" aria-labelledby={activeTabId}>
                            {
                                // list by tag
                                currentActiveTagIndex > -1 &&
                                <div className="px-16 div-template-list">
                                    <TemplateList>
                                        {(categories[currentActiveTagIndex].children||[]).map(item=>{return (
                                            <TemplateListItem key={item.id} src={`${baseUrl}/api/file/download?type=img&filepath=${item.image}`} name={item.name} onClick={()=>this.onClickTemplate(item)}></TemplateListItem>
                                        )})}
                                    </TemplateList>
                                </div>
                            }
                            {
                                // MostPopular
                                currentActiveTagIndex === -1 && mostPopular.length > 0 &&
                                <div className="px-16 div-xscroll-list">
                                    <div className='list-item-header'>
                                        <span className='tag-title'>{MostPopular}</span>
                                    </div>
                                    <XscrollList>
                                        {mostPopular.map(item=>{return (
                                            <TemplateListItem key={item.id} src={`${baseUrl}/api/file/download?type=img&filepath=${item.image}`} name={item.name} onClick={()=>this.onClickTemplate(item)}></TemplateListItem>
                                        )})}
                                    </XscrollList>
                                </div>
                            }
                            {
                                // all list
                                currentActiveTagIndex === -1 &&
                                categories.map((item,index)=>{return (
                                    item.children && <div key={item.id} className="px-16 div-xscroll-list">
                                        <div className='list-item-header'>
                                            <span className='tag-title'>{item.name}</span>
                                            {
                                                item.showSeeMore &&
                                                <span className='see-more' role="button" tabIndex={0} aria-label={intl.formatMessage({id: 'AriaSeeMore'}, {name: item.name})} onClick={()=>this.onClickSeeMore(item,index)} onKeyDown={(e)=>this.onSeeMoreKeyDown(e,item,index)}>{More} <RightOutlined style={{fontSize:10}} /></span>
                                            }
                                        </div>
                                        <XscrollList onScrollEnd={()=>this.onXscrollListEnd(item,index)} onToggleHandle={(toggle)=>this.onToggleHandle(toggle, index)}>
                                            {(item.children||[]).map(subItem=>{return (
                                                <TemplateListItem key={subItem.id} src={`${baseUrl}/api/file/download?type=img&filepath=${subItem.image}`} name={subItem.name} onClick={()=>this.onClickTemplate(subItem)}></TemplateListItem>
                                            )})}
                                        </XscrollList>
                                    </div>
                                )})
                            }
                        </div>
                    }
                    {
                        showLoading && <Loading></Loading>
                    }
                    {
                        showEmpty && <Empty></Empty>
                    }
                </section>
                {
                    previewOption.display && <Modal className="preview-modal" centered footer={null} getContainer={false} closeIcon={<CloseIcon className="ant-modal-close-icon" ariaLabel={AriaCloseDialog}></CloseIcon>} visible={true} onCancel={this.onCancel} aria-label={previewOption.info.name}>
                        <Preview id={previewOption.info.id} cid={previewOption.info.category_id} onCancel={this.onCancel}></Preview>
                    </Modal>
                }
            </div>
        )
    }
}
export default Index;
